var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-button-new",on:{"click":_vm.newEvent}},[_vm._v("\n  新しいイベントの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }